import { TriangleAlertIcon } from "lucide-react";
import {
  SCHEDULE_SCOPE_ALERT_BODY,
  SCHEDULE_SCOPE_ALERT_TITLE,
} from "@/lib/automationSchedule";

/**
 * Warns that a schedule with no conditionals sweeps every open card on the
 * board. Shown in the builder while the trigger set is unscoped, and on the
 * saved automation, because the scope does not stop being real after save.
 *
 * Colors are pinned to steps the project's Tailwind theme actually defines.
 * `amber` is overridden in tailwind.config.js with only DEFAULT/50/100/200/300/950,
 * so the usual amber-600/700/800 silently produce no CSS. The text color is set
 * explicitly rather than inherited: the app shell sets `text-slate-100`, which is
 * invisible on a light panel.
 * @returns {JSX.Element} The alert.
 */
export function ScheduleScopeAlert() {
  return (
    <div
      role="status"
      className="flex gap-2 rounded-md border border-amber-300 bg-amber-100 p-3 text-amber-950"
    >
      <TriangleAlertIcon className="h-4 w-4 shrink-0 translate-y-0.5" />
      <div className="text-sm">
        <p className="font-semibold">{SCHEDULE_SCOPE_ALERT_TITLE}</p>
        <p>{SCHEDULE_SCOPE_ALERT_BODY}</p>
      </div>
    </div>
  );
}
